const MarkSafe = ({Element, value, ...props}) => (
    <Element {...props} dangerouslySetInnerHTML={{__html: value}} />
);

MarkSafe.defaultProps = {
    Element: 'span',
};

export default MarkSafe;
